import { AppContext, IAppContext } from "../../util/context";
import React, { useEffect, useMemo, useState } from "react";
import { handleBackClick, handleScrollIntoView, resolveVisibleStepIndex } from "../Handlers/handlers";

import { FormData } from "../FormClient/FormClient.types";
import Step from "../Steps/Step";
import { StepField } from "../Steps/Step.types";
import block from 'bem-css-modules';
import { handleStepSubmit } from "../Handlers/handleStepSubmit";
import { handleStepTransition } from "../Handlers/handleStepTransition";
import styles from  "./FormViewer.module.scss";
import "../../styles/custom-classes.scss";
import ProgressBar from "../ProgressBar";

const FormViewer = (props: { formData: FormData }) => {
  const { 
    formData: {
      steps,
      settings,
    },
  } = props;

  const b = block(styles);

  const [disableButton, setDisableButton] = useState(false);
  const [activeStepIndex, setActiveStepIndex] = useState(0);
  const [prevStepIndex, setPrevStepIndex] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [breadcrumb, setBreadcrumb] = useState<number[]>([0]);

  const { locale = "de-DE", progressBar, customCssClass } = settings[0] || {};
  const localizedErrorMessages: { [key: string]: string } = {
    "de-DE": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    "fr-FR": "Une erreur est survenue. Veuillez réessayer.",
  }

  const updateBreadcrumb = (indexOrArray: number | number[]) => {
    if (Array.isArray(indexOrArray)) {
      setBreadcrumb(indexOrArray);
      return;
    }
    const newBreadcrumb = [...breadcrumb];
    newBreadcrumb.push(indexOrArray);
    setBreadcrumb(newBreadcrumb);
  }

  const updateActiveStepIndex = (index: number) => {
    setActiveStepIndex(index);
  }
  const updateDisableButton = (value: boolean) => setDisableButton(value);
  const updateErrorMessage = (value: string) => setErrorMessage(value);
  const updatePrevStepIndex = (index: number) => setPrevStepIndex(index);

  const appContext = useMemo(() => {
    return { 
      steps,
      settings: settings[0],
      activeStepIndex,
      prevStepIndex,
      disableButton,
      breadcrumb,
      updateBreadcrumb,
      updateActiveStepIndex,
      updateDisableButton,
      handleStepTransition,
      handleStepSubmit,
      handleBackClick,
      updateErrorMessage,
      updatePrevStepIndex,
    } as IAppContext;
  }, [steps, settings, activeStepIndex, disableButton, prevStepIndex]);

  useEffect(() => {
    activeStepIndex > 0 && handleScrollIntoView();
  }, [activeStepIndex]);

  useEffect(() => {
    const firstVisibleIndex = resolveVisibleStepIndex(steps, 0);
    if (firstVisibleIndex > 0) updateActiveStepIndex(firstVisibleIndex);
  }, [steps]);

  useEffect(() => {
    const hash = window.location.hash;
    const match = hash.match(/#fc-step:(\d+)/);
    if (match) {
      const stepIndex = parseInt(match[1], 10);
      if (!isNaN(stepIndex) && stepIndex >= 0 && stepIndex < steps.length) {
        setActiveStepIndex(stepIndex);
      }
    }
  }, [steps]);

  return (
    <AppContext.Provider value={appContext}>
      <div className={`${b()} ${customCssClass}`} id="formClient">
        {errorMessage &&
          <div className={b("alert")} role="alert">
            <strong>Error: </strong> {localizedErrorMessages[locale]}
            <button type="button" onClick={()=>updateErrorMessage("")} className={b("close")} data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>}
        <div className={b("slider")}>
          {progressBar ? <ProgressBar /> : null}
          {steps?.map((step: StepField, i: number) => {
            return <Step
              key={i}
              stepIndex={i}
              stepData={step}
            />
          })}
        </div>
      </div>
    </AppContext.Provider>
  )
}

export default FormViewer;